import { Injectable } from '@angular/core';
import {
    IGetBookingsAirResponse, IGetBookingsStayResponse, ISectorAir,
    ISsr,
    TGetBookingResponse
} from "libraries/service/resources/booking/interfaces/IGetBookings";
import { BookingType, BookingXType } from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import {Ssr} from "@afidium/ts-facade";
import { BookingXStatus } from "libraries/component/booking/booking-status/booking-status.service";
import * as moment from "moment";

@Injectable({
    providedIn: 'root',
})
export class BookingAirToolsService {

    public hasServices(bookingAir: IGetBookingsAirResponse): boolean {
        const isAirBooking: boolean = (bookingAir.type || []).includes(BookingType.air);
        const hasServices: boolean = Boolean(bookingAir.service?.length);
        const hasAsvcSsr: boolean = Boolean(
            bookingAir.ssr?.length &&
            bookingAir.ssr?.find((ssrItem: ISsr): boolean => ssrItem.code === 'ASVC')
        );

        return  isAirBooking && (hasServices || hasAsvcSsr);
    }

    // #31745 - Made to check if booking has services when booking has 'xsl_direct_convert_xft2json' format
    public hasServicesNewFormat(bookingAir: any): boolean {
        if(!bookingAir.booking){
            return false;
        }

        const isAirBooking: boolean = (bookingAir.booking.typeArray || []).includes("Air");
        const hasServices: boolean = Boolean(bookingAir.booking.serviceArray?.length);
        const hasAsvcSsr: boolean = Boolean(
            bookingAir.booking.ssrArray?.length &&
            bookingAir.booking.ssrArray?.find((ssrItem: Ssr): boolean => ssrItem.code === 'ASVC')
        );

        return  isAirBooking && (hasServices || hasAsvcSsr);
    }

    /**
     * Compute if can add services in a air Booking
     * @param hasAddServicesPermission
     * @param bookingData
     * @param isOneSectorLowCost
     */
    public canAddServices(hasAddServicesPermission: boolean, bookingData: TGetBookingResponse, isOneSectorLowCost: boolean): boolean {
        return hasAddServicesPermission &&
            bookingData.type && bookingData.type.includes(BookingType.air) &&
            !isOneSectorLowCost &&
            bookingData.xType && bookingData.xType === BookingXType.individual &&
            (
                (bookingData.host !== "TRAVELFUSION" && bookingData.host !== "GALILEO") ||
                (bookingData.xStatus && bookingData.xStatus === BookingXStatus.Confirm && bookingData.begin && moment(bookingData.begin, 'YYYY-MM-DD') > moment())
            );

    }

    public isOneSectorLowCost(bookingData: TGetBookingResponse): boolean {
        return (((bookingData as TGetBookingResponse).sector as ISectorAir[]) || [])
            .some((sector: ISectorAir): boolean => !sector.category || sector.category === 'lowcost' || sector.xType !== 'air');
    }
}
